import type { orderItem } from 'src/shared/frontendTypes/warenkorb'
import { getCartLinePrice } from 'src/functions/cartPriceLock'

/** Use the same quantity and stock pricing as checkout, including mixed-price lines. */
export const getCartLinePresentation = (item: orderItem) => {
  const total = getCartLinePrice(item.price, item.qty, { onlyStock: item.onlyStock, stock: item.stock })
  const regularTotal = typeof item.price === 'number' ? total : item.price.regularPrice * item.qty
  const visibleDiscount = typeof item.price !== 'number' && item.price.type !== 'invisible'
  const saving = visibleDiscount ? Math.max(0, Math.round((regularTotal - total) * 100) / 100) : 0
  return {
    total,
    regularTotal,
    saving,
    percent: saving > 0 && regularTotal > 0 && typeof item.price !== 'number' && item.price.showPercent !== false
      ? Math.round(saving / regularTotal * 100)
      : 0,
  }
}

export const getSurchargeProgress = (subtotal: number, surcharge: number, threshold: number) => ({
  remaining: surcharge > 0 ? Math.max(0, Math.round((threshold - subtotal) * 100) / 100) : 0,
  percent: threshold > 0 ? Math.max(0, Math.min(100, subtotal / threshold * 100)) : 100,
})
